<template>

  <v-number-input
    :label="`${ChannelRegistry.findTitle(channel)} (${exChannelId})`"
    prefix="$"
    v-model="model"
    :precision="2"
    :rules="rules"
    density="compact"
    :class="{'font-italic': spot}"
    hide-details
  />

</template>

<script setup lang="ts">

import { computed } from 'vue'
import { useRules } from 'vuetify/labs/rules'

// misc
import ChannelRegistry from '../../../../channels/ChannelRegistry'

interface Props {
  channel: string
  exChannelId: string
  originalChannelCost: null | number
  defaultChannelCost: null | number
}

const props = defineProps<Props>()

const rulesComposable = useRules()
const model = defineModel<null | number>({required: true})

/**
 *
 */

const spot = computed<boolean>(() => {
  return (
    props.defaultChannelCost !== null &&
    // @ts-ignore
    ![null, undefined, ''].includes(model.value) &&
    model.value !== props.defaultChannelCost
  )
})

const rules = [
  rulesComposable!.required!(),
  rulesComposable!.min!(0.01),
  (value: any) => {
    if (props.channel === 'spothero' && value > 250) {
      return 'SpotHero rates can\'t exceed $250'
    }
    return true
  }
]

</script>
